// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1JaRZ","head":"Table_head__P8kdx","col":"Table_col__aRYJR"};